import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import ReportToolComponent from './components/ReportToolComponent';

const ReportTool = () => {
  return renderComponent(<ReportToolComponent />);
};

export default ReportTool;
